import { Box, Stack } from "@mui/material";
import { useSelector } from "react-redux";
import { convert1DArrayTo2DArray } from "../../../helpers/convert1DArrayTo2DArray";
import { RootState } from "../../../redux/store";
import { slideBasedOnMarginLeft, slideBasedOnMarginRight, fadeIn, scaleUP, transitionCubicBezier } from "../../../shared/animations";
import { ISchoolPageInfoDisplayBox, NswContent, SchoolPageInfoDisplayBoxDesBox } from "../components";
import styles from "../index.module.scss";
import { ReactNode } from "react";
import pxToRem from "../../../helpers/pxToRem";

export const SchoolPageInfoDisplayBoxNSW = ({
    loadedAnimation,
    title,
    description,
    leftTopBgImg,
    leftTopBgImgAlt,
    leftBottomBgImg,
    leftBottomBgImgAlt,
    deviceImg,
    deviceImgAlt,
    contents,
    rowDirectionReversed,
    underScoreColor,
    desBoxBgColor,
}: ISchoolPageInfoDisplayBox) => {
    const screenType = useSelector((state: RootState) => state.ui.screenType);
    const slideInAnimation = rowDirectionReversed
        ? slideBasedOnMarginLeft(loadedAnimation, "0px", "-200px")
        : slideBasedOnMarginRight(loadedAnimation, "0px", "-200px");

    return (
        <Stack className={`flex_row_center`}>
            <Stack className={`${styles.sc_container}`} sx={{width: `${pxToRem(1200)} !important`, padding:`0 ${pxToRem(40)}`}}>
                <Box
                    className={`${styles.sc_title} heading1`}
                    sx={{
                        ...fadeIn(loadedAnimation),
                        ...scaleUP(loadedAnimation),
                        ...transitionCubicBezier,
                        marginBottom: pxToRem(24)
                    }}
                >
                    {title}
                </Box>
                <Stack
                    className={styles.sc_bottomStack}
                    direction={
                        screenType === "MOBILE"
                            ? "column"
                            : rowDirectionReversed
                                ? "row-reverse"
                                : "row"
                    }
                    alignItems='center'
                    justifyContent='space-between'
                    columnGap={'17%'}
                    rowGap={pxToRem(40)}
                >
                    <Stack
                        className={styles.SchoolPageInfoDisplayBox_contentStack}
                        direction={"column"}
                    >
                        <NSWContentBox icon={<svg width="140" height="141" viewBox="0 0 140 141" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M70 114.211C94.917 114.211 115.439 93.6445 115.439 68.7715C115.439 43.8984 94.8291 23.332 69.9561 23.332C46.8408 23.332 27.5049 41.042 24.9121 63.498C27.6367 62.8828 31.2402 62.707 34.1406 63.1904C36.7334 45.7002 51.6748 32.4287 69.9561 32.4287C90.127 32.4287 106.387 48.6006 106.387 68.7715C106.387 78.3955 102.695 87.0967 96.5869 93.5566C92.0605 88.5469 82.4805 83.9766 69.9561 83.9766C66.0449 83.9766 62.3975 84.416 59.1016 85.207C59.6289 87.3164 59.8926 89.5137 59.8926 91.7549C59.8926 98.918 57.124 105.554 52.6416 110.695C58.0029 112.937 63.8916 114.211 70 114.211ZM69.9561 76.7695C78.4814 76.8135 85.1172 69.5625 85.1172 60.1582C85.1172 51.2812 78.4375 43.8545 69.9561 43.8545C61.5186 43.8545 54.751 51.2812 54.8389 60.1582C54.8828 69.5625 61.4307 76.6816 69.9561 76.7695ZM30.9766 114.431C43.2812 114.431 53.6084 104.147 53.6084 91.7549C53.6084 79.3623 43.4131 69.123 30.9766 69.123C18.584 69.123 8.34473 79.3623 8.34473 91.7549C8.34473 104.191 18.584 114.431 30.9766 114.431ZM28.3398 105.114C27.5049 105.114 26.4941 104.807 25.835 104.06L17.5732 95.0508C17.0898 94.5674 16.7822 93.6885 16.7822 92.9414C16.7822 91.0078 18.2764 89.7773 19.9463 89.7773C21.001 89.7773 21.792 90.1729 22.3193 90.7881L28.1641 97.1602L39.3262 81.6475C39.9414 80.8125 40.9082 80.2852 42.0068 80.2852C43.7207 80.2852 45.1709 81.6475 45.1709 83.4053C45.1709 83.9766 44.9512 84.6357 44.5117 85.251L30.9766 103.928C30.4492 104.675 29.4385 105.114 28.3398 105.114Z" fill="white" /> </svg>}
                            title={"Streamlined admin support"} desc={"We employ our Teachers as casual employees, which means we handle all admin and payroll needs so you don't have to!"} 
                            bgColor={styles.primaryPurple400}    
                        />
                        <NSWContentBox icon={<svg width="141" height="141" viewBox="0 0 141 141" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M53.1975 116.804H87.987C95.5115 116.804 100.513 111.926 100.513 104.675V32.7803C100.513 25.5293 95.5115 20.6514 87.987 20.6514H53.1975C45.5845 20.6514 40.4502 25.5293 40.4502 32.7803V104.675C40.4502 111.926 45.5845 116.804 53.1975 116.804ZM54.6581 107.971C51.1615 107.971 49.1254 106.037 49.1254 102.697V34.7578C49.1254 31.418 51.1615 29.5283 54.6581 29.5283H86.3493C89.846 29.5283 91.882 31.418 91.882 34.7578V102.697C91.882 106.037 89.846 107.971 86.3493 107.971H77.6741V106.433C77.6741 104.499 76.3905 103.225 74.4873 103.225H66.5645C64.617 103.225 63.3776 104.499 63.3776 106.433V107.971H54.6581Z" fill="white" /> </svg>}
                            title={"Bookings at your fingertips"} desc={"Our user-friendly mobile app allows you to source and manage your casual relief teacher bookings at any time."} 
                            bgColor={styles.primaryPurple500}    
                        />
                    </Stack>
                    <Box className={styles.sc_imgWrapper}>
                        <img
                            src={leftBottomBgImg}
                            alt={leftBottomBgImgAlt}
                            className={styles.sp_sc_bg_pink}
                        />
                        <img
                            src={leftTopBgImg}
                            alt={leftTopBgImgAlt}
                            className={styles.sp_sc_bg_yellow}
                        />
                        <img
                            src={deviceImg}
                            alt={deviceImgAlt}
                            className={styles.sp_sc_device}
                        />
                    </Box>

                </Stack>
            </Stack>
        </Stack>
    );
};

interface INSWContentBox {
    icon: ReactNode;
    title: string;
    desc: string;
    bgColor: string;
}
const NSWContentBox = ({ icon, title, desc, bgColor }: INSWContentBox) => {
    const screenType = useSelector((state: RootState) => state.ui.screenType);

    return (
        <Stack className={styles.nswContentBox} sx={{backgroundColor: bgColor}}>
            {icon}
            <Stack>
                <h5 className={`${screenType === "PC"
                    ? "title_large"
                    : "title_medium"
                    }`}>{title}</h5>
                <p className={`${screenType === "PC" ? "title_medium" : "label_large"
                    }`}>{desc}</p>
            </Stack>
        </Stack>
    )
}

export default NSWContentBox;